import { dateUtils } from 'utils/date';

export const isContractInBinding = (contractEndDate?: string | null) => {
  if (!contractEndDate) {
    return false;
  }

  return dateUtils.isAfter(new Date(contractEndDate), new Date());
};
